// import React, { createContext, useEffect, useState } from "react";
// import Cookies from "js-cookie";
// import { ClientDetails } from "./apis/auth/index";
// import {
//   Settings,
//   AllGames,
//   AllLiveMarketsData,
//   OnlyLiveGamesMatches,
//   MarketAnalysisLiveGamesMatches,
// } from "./apis/common/index";
// import { CookiesName } from "./common";
// import { IDS } from "./IDS";
// import { io } from "socket.io-client";
// import { LiveBets, UnmatchBets } from "./apis/bets";
// export const Context = createContext();

// const AppContext = ({ children }) => {
//   const IMG_URL = "http://127.0.0.1:5555";
//   const SOCKET = "ws://127.0.0.1:5555";

//   // const IMG_URL = "http://192.168.16.53:5555";
//   // const SOCKET = "ws://192.168.16.53:5555";

//   // const IMG_URL = "http://192.168.1.73:5555";
//   // const SOCKET = "ws://192.168.1.73:5555";

//   // const IMG_URL = "http://start555node.profcyma.org:5555";
//   // const SOCKET = "ws://start555node.profcyma.org:5555";

//   // const IMG_URL = "https://start555node.profcyma.org:5555";
//   // const SOCKET = "wss://start555node.profcyma.org:5555";

//   // # # Production Environment Variable
//   // const IMG_URL = "https://node.star555.in";
//   // const SOCKET = "wss://node.star555.in";

//   //
//   const [ChangePass, setChangePass] = useState(false);
//   const [User, setUser] = useState({});
//   const [LiveAmount, setLiveAmount] = useState([]);
//   const [AppSetup, setAppSetup] = useState({});
//   const [Games, setGames] = useState([]);
//   const [Markets, setMarkets] = useState([]);
//   const [Fancy, setFancy] = useState([]);
//   const [Scorecard, setScorecard] = useState({});
//   const [BallEvent, setBallEvent] = useState({});
//   const [LiveGamesMatches, setLiveGamesMatches] = useState([]);
//   const [
//     MarketAnalysisLiveGamesMatche,
//     setMarketAnalysisLiveGamesMatches,
//   ] = useState([]);
//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     // Create a new WebSocket connection
//     const newSocket = io(SOCKET, {
//       reconnection: true,
//       reconnectionAttempts: 5,
//       reconnectionDelay: 1000,
//       transports: ["websocket"],
//     });

//     // const newSocket = io(`wss://${SOCKET}`, {
//     //   reconnection: true,
//     //   reconnectionAttempts: 5,
//     //   reconnectionDelay: 1000,
//     //   transports: ["websocket"],
//     // });

//     setSocket(newSocket);

//     newSocket.on("connect", () => {
//       console.log("Connected to WebSocket server");
//     });

//     newSocket.on("matchodds", async (data) => {
//       // console.log("Received market data:", data);
//       await setMarkets(data);
//     });

//     newSocket.on("fancyodds", (data) => {
//       // console.log("Received market data:", data);
//       setFancy(data);
//     });

//     newSocket.on("scorecard", async (data) => {
//       console.log("Received scorecard data:", data?.matche_id);
//       await setScorecard(data);
//     });

//     newSocket.on("ball_event", async (data) => {
//       console.log("Received ball_event data:", data?.matche_id);
//       await setBallEvent(data);
//     });

//     newSocket.on("disconnect", () => {
//       console.log("Disconnected from WebSocket server");
//     });

//     newSocket.on("connect_error", (error) => {
//       console.error("Connection error:", error);
//     });

//     newSocket.on("error", (error) => {
//       console.error("WebSocket error:", error);
//     });

//     // Clean up the connection when the component unmounts
//     return () => {
//       newSocket.disconnect();
//     };
//   }, []);

//   // console.log("Match Odds ", Markets);

//   const [Cart, setCart] = useState({});

//   const GETUser = async () => {
//     const token = Cookies.get(CookiesName);
//     if (token) {
//       const response = await ClientDetails();
//       if (response?.success) {
//         setChangePass(response?.data?.user_details?.change_password);
//         setUser(response?.data?.user_details);
//       }
//     }
//   };

//   const GETSettings = async () => {
//     const response = await Settings();
//     if (response?.success) {
//       setAppSetup(response?.data);
//     }
//   };

//   const GETAllGames = async () => {
//     const response = await AllGames();
//     if (response?.success) {
//       setGames(response?.data);
//     }
//   };

//   const GETOnlyLiveGamesMatches = async () => {
//     {
//       const response = await OnlyLiveGamesMatches();
//       if (response?.success) {
//         setLiveGamesMatches(response?.data);
//       }
//     }

//     {
//       const response = await MarketAnalysisLiveGamesMatches();
//       if (response?.success) {
//         setMarketAnalysisLiveGamesMatches(response?.data);
//       }
//     }
//   };

//   useEffect(() => {
//     GETSettings();
//     // if (User?.id) {
//     GETUser();

//     // }
//     const intervalId1 = setInterval(GETUser, 3000);
//     return () => {
//       clearInterval(intervalId1);
//     };
//   }, []);

//   // useEffect(() => {
//   //   GETAllLiveMarketsData();
//   //   const intervalId1 = setInterval(GETAllLiveMarketsData, 2500);

//   //   return () => {
//   //     clearInterval(intervalId1);
//   //   };
//   // }, []);

//   useEffect(() => {
//     GETAllGames();
//     GETOnlyLiveGamesMatches();
//     const intervalId1 = setInterval(GETAllGames, 10000);
//     const intervalId2 = setInterval(GETOnlyLiveGamesMatches, 10000);
//     return () => {
//       clearInterval(intervalId1);
//       clearInterval(intervalId2);
//     };
//   }, []);

//   const [matched_bets, setmatched_bets] = useState([]);
//   const [unmatched_bets, setunmatched_bets] = useState([]);
//   const GetData = async () => {
//     try {
//       {
//         const res = await LiveBets();
//         setmatched_bets(res.data);
//       }

//       {
//         const res = await UnmatchBets();
//         setunmatched_bets(res.data);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (!User?.id) return;
//     GetData();
//     const intervalId = setInterval(() => {
//       GetData();
//     }, 5000);
//     return () => clearInterval(intervalId);
//   }, [User?.id]);

//   return (
//     <Context.Provider
//       value={{
//         // IMG_URL
//         IMG_URL,
//         // Cookies
//         Cookies,
//         // AppSetup
//         AppSetup,
//         // User
//         User,
//         setUser,
//         GETUser,
//         // Games
//         Games,
//         // Markets
//         Markets,
//         // Fancy
//         Fancy,
//         // LiveGamesMatches
//         LiveGamesMatches,
//         // MarketAnalysisLiveGamesMatche
//         MarketAnalysisLiveGamesMatche,
//         // Cart
//         Cart,
//         setCart,
//         // Scorecard
//         Scorecard,
//         //
//         LiveAmount,
//         setLiveAmount,
//         //
//         BallEvent,
//         //
//         ChangePass,
//         setChangePass,
//         //
//         matched_bets,
//         unmatched_bets,
//       }}
//     >
//       {children}
//     </Context.Provider>
//   );
// };

// export default AppContext;
// ------------------------------------------------------------------------
import React, { createContext, useEffect, useState, useCallback } from "react";
import Cookies from "js-cookie";
import { ClientDetails } from "./apis/auth/index";
import {
  Settings,
  AllGames,
  OnlyLiveGamesMatches,
  MarketAnalysisLiveGamesMatches,
} from "./apis/common/index";
import { CookiesName } from "./common";
import { io } from "socket.io-client";
import { LiveBets, UnmatchBets } from "./apis/bets";

export const Context = createContext();

const AppContext = ({ children }) => {
  // Use environment variables for different environments
  // const IMG_URL = "http://127.0.0.1:1802";
  // const SOCKET = "ws://127.0.0.1:1802";

  // const IMG_URL = "http://192.168.16.53:1802";
  // const SOCKET = "ws://192.168.16.53:1802";

  // const IMG_URL = "http://192.168.16.38:1802";
  // const SOCKET = "ws://192.168.16.38:1802";

  // # # Production Environment Variable

  const IMG_URL = "https://bet247.star555.in";
  const SOCKET = "wss://bet247.star555.in";

  // State declarations
  const [ChangePass, setChangePass] = useState(false);
  const [User, setUser] = useState({});
  const [LiveAmount, setLiveAmount] = useState([]);
  const [AppSetup, setAppSetup] = useState({});
  const [Games, setGames] = useState([]);
  const [Markets, setMarkets] = useState([]);
  const [Fancy, setFancy] = useState([]);
  const [Scorecard, setScorecard] = useState({});
  const [BallEvent, setBallEvent] = useState({});
  const [LiveGamesMatches, setLiveGamesMatches] = useState([]);
  const [
    MarketAnalysisLiveGamesMatche,
    setMarketAnalysisLiveGamesMatches,
  ] = useState([]);
  const [socket, setSocket] = useState(null);
  const [Cart, setCart] = useState({});
  const [matched_bets, setmatched_bets] = useState([]);
  const [unmatched_bets, setunmatched_bets] = useState([]);
  const [loading, setLoading] = useState({
    user: false,
    games: false,
    bets: false,
  });

  // WebSocket connection
  useEffect(() => {
    const newSocket = io(SOCKET, {
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      transports: ["websocket"],
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("Connected to WebSocket server");
    });

    newSocket.on("matchodds", (data) => {
      setMarkets(data);
    });

    newSocket.on("fancyodds", (data) => {
      setFancy(data);
    });

    // newSocket.on("scorecard", (data) => {
    //   console.log("Received scorecard data:", data?.matche_id);
    //   setScorecard(data);
    // });

    // newSocket.on("ball_event", (data) => {
    //   console.log("Received ball_event data:", data?.matche_id);
    //   setBallEvent(data);
    // });

    newSocket.on("disconnect", () => {
      console.log("Disconnected from WebSocket server");
    });

    newSocket.on("connect_error", (error) => {
      console.error("Connection error:", error);
    });

    newSocket.on("error", (error) => {
      console.error("WebSocket error:", error);
    });

    return () => {
      newSocket.disconnect();
    };
  }, [SOCKET]);

  // API functions with useCallback to prevent unnecessary re-renders
  const GETUser = useCallback(async () => {
    const token = Cookies.get(CookiesName);
    if (!token) return;

    setLoading((prev) => ({ ...prev, user: true }));
    try {
      const response = await ClientDetails();
      if (response?.success) {
        setChangePass(response?.data?.user_details?.change_password || false);
        setUser(response?.data?.user_details || {});
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setLoading((prev) => ({ ...prev, user: false }));
    }
  }, []);

  const GETSettings = useCallback(async () => {
    try {
      const response = await Settings();
      if (response?.success) {
        setAppSetup(response?.data || {});
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  }, []);

  const GETAllGames = useCallback(async () => {
    setLoading((prev) => ({ ...prev, games: true }));
    try {
      const response = await AllGames();
      if (response?.success) {
        setGames(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching games:", error);
    } finally {
      setLoading((prev) => ({ ...prev, games: false }));
    }
  }, []);

  const GETOnlyLiveGamesMatches = useCallback(async () => {
    try {
      const [liveMatchesRes, marketAnalysisRes] = await Promise.all([
        OnlyLiveGamesMatches(),
        MarketAnalysisLiveGamesMatches(),
      ]);

      if (liveMatchesRes?.success) {
        setLiveGamesMatches(liveMatchesRes?.data || []);
      }

      if (marketAnalysisRes?.success) {
        setMarketAnalysisLiveGamesMatches(marketAnalysisRes?.data || []);
      }
    } catch (error) {
      console.error("Error fetching live matches:", error);
    }
  }, []);

  const GetBets = useCallback(async () => {
    if (!User?.id) return;

    setLoading((prev) => ({ ...prev, bets: true }));
    try {
      const [liveBetsRes, unmatchBetsRes] = await Promise.all([
        LiveBets(),
        UnmatchBets(),
      ]);

      setmatched_bets(liveBetsRes?.data || []);
      setunmatched_bets(unmatchBetsRes?.data || []);
    } catch (error) {
      console.error("Error fetching bets:", error);
    } finally {
      setLoading((prev) => ({ ...prev, bets: false }));
    }
  }, [User?.id]);

  // Initial data fetching
  useEffect(() => {
    GETSettings();
    GETUser();
  }, [GETSettings, GETUser]);

  // Polling for user data
  useEffect(() => {
    const intervalId = setInterval(GETUser, 3000);
    return () => clearInterval(intervalId);
  }, [GETUser]);

  // Polling for games data
  useEffect(() => {
    GETAllGames();
    GETOnlyLiveGamesMatches();

    const gamesInterval = setInterval(GETAllGames, 10000);
    const matchesInterval = setInterval(GETOnlyLiveGamesMatches, 10000);

    return () => {
      clearInterval(gamesInterval);
      clearInterval(matchesInterval);
    };
  }, [GETAllGames, GETOnlyLiveGamesMatches]);

  // Polling for bets data
  useEffect(() => {
    GetBets();

    const betsInterval = setInterval(GetBets, 5000);
    return () => clearInterval(betsInterval);
  }, [GetBets]);

  return (
    <Context.Provider
      value={{
        // URLs
        IMG_URL,
        SOCKET,

        // Cookies utility
        Cookies,

        // App Setup
        AppSetup,

        // User
        User,
        setUser,
        GETUser,

        // Games
        Games,

        // Markets & Fancy
        Markets,
        Fancy,

        // Live Matches
        LiveGamesMatches,
        MarketAnalysisLiveGamesMatche,

        // Cart
        Cart,
        setCart,

        // Scorecard & Events
        Scorecard,
        BallEvent,

        // Live Amount
        LiveAmount,
        setLiveAmount,

        // Password Change
        ChangePass,
        setChangePass,

        // Bets
        matched_bets,
        unmatched_bets,

        // Loading States
        loading,

        // Socket
        socket,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
